// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_ListallticketsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Tickets_TicketRow } from './Tickets_TicketRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Tickets_ListallticketsResponseDados = Tickets_TicketRow[];

export type Tickets_ListallticketsResponse = ApiResponse<Tickets_ListallticketsResponseDados>;

registerResponseContract('Tickets_ListallticketsResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:             { type: 'number',  required: true },
      Titulo:         { type: 'string',  required: true },
      Prioridade:     { type: 'number',  required: true },
      Descricao:      { type: 'string',  required: true },
      Usuario:        { type: 'string',  required: true },
      CategoriaID:    { type: 'number',  required: true },
      Categoria_nome: { type: 'string',  required: true },
      created_at:     { type: 'string',  required: false },
      updated_at:     { type: 'string',  required: false },
    },
  },
})
